import {
  ApartmentOutlined,
  ApiOutlined,
  AppstoreOutlined,
  AuditOutlined,
  BankOutlined,
  BarChartOutlined,
  BellOutlined,
  BookOutlined,
  CalendarOutlined,
  CarOutlined,
  CheckCircleOutlined,
  DashboardOutlined,
  DeploymentUnitOutlined,
  EditOutlined,
  EnvironmentOutlined,
  FieldTimeOutlined,
  FileAddOutlined,
  FileProtectOutlined,
  FileSearchOutlined,
  FileTextOutlined,
  FolderOpenOutlined,
  ForkOutlined,
  GlobalOutlined,
  HistoryOutlined,
  KeyOutlined,
  MessageOutlined,
  NotificationOutlined,
  OrderedListOutlined,
  PieChartOutlined,
  ProfileOutlined,
  ProjectOutlined,
  RiseOutlined,
  SafetyCertificateOutlined,
  ScheduleOutlined,
  SettingOutlined,
  ShopOutlined,
  TeamOutlined,
  ThunderboltOutlined,
  ToolOutlined,
} from '@ant-design/icons';
import type { MenuDataItem } from '@ant-design/pro-components';
import { createElement } from 'react';
import { ROUTES } from '../constants/routes';

// Keys identify direct sidebar entries, including expandable business groups.
// Outlined icons inherit the native menu's theme and selected-state colors.
const SIDEBAR_ICONS: Record<string, MenuDataItem['icon']> = {
  [ROUTES.overview]: createElement(DashboardOutlined),
  // 待办中心拆两个子页，图标挂到子项上；分组自身也要有图标
  'nav.todos': createElement(CheckCircleOutlined),
  [ROUTES.todoApproval]: createElement(AuditOutlined),
  [ROUTES.todoBusiness]: createElement(CheckCircleOutlined),
  [ROUTES.park.profile]: createElement(EnvironmentOutlined),
  'nav.spaces': createElement(AppstoreOutlined),
  [ROUTES.park.otherAssets]: createElement(ApartmentOutlined),
  [ROUTES.asset.ledger]: createElement(ProfileOutlined),
  [ROUTES.asset.suppliers]: createElement(ShopOutlined),
  [ROUTES.asset.reminders]: createElement(BellOutlined),
  [ROUTES.contracts.management]: createElement(FileTextOutlined),
  'nav.contractSettings': createElement(SettingOutlined),
  [ROUTES.contracts.types]: createElement(SettingOutlined),
  'nav.contractHandling': createElement(EditOutlined),
  [ROUTES.contracts.all]: createElement(FileSearchOutlined),
  [ROUTES.contracts.mine]: createElement(EditOutlined),
  [ROUTES.contracts.todo]: createElement(CheckCircleOutlined),
  [ROUTES.contracts.templates]: createElement(FolderOpenOutlined),
  [ROUTES.contracts.billingRules]: createElement(OrderedListOutlined),
  'nav.leases': createElement(FileTextOutlined),
  [ROUTES.enterprises.list]: createElement(BankOutlined),
  'nav.leads': createElement(FileSearchOutlined),
  'nav.customers': createElement(BankOutlined),
  [ROUTES.attraction.leadAll]: createElement(FileSearchOutlined),
  [ROUTES.attraction.leadMine]: createElement(TeamOutlined),
  [ROUTES.attraction.leadPool]: createElement(FolderOpenOutlined),
  [ROUTES.attraction.customerAll]: createElement(BankOutlined),
  [ROUTES.attraction.customerMine]: createElement(TeamOutlined),
  [ROUTES.attraction.customerPool]: createElement(FolderOpenOutlined),
  [ROUTES.attraction.leads]: createElement(FileSearchOutlined),
  [ROUTES.attraction.customers]: createElement(BankOutlined),
  [ROUTES.attraction.contacts]: createElement(TeamOutlined),
  [ROUTES.attraction.opportunities]: createElement(ProjectOutlined),
  [ROUTES.attraction.orders]: createElement(OrderedListOutlined),
  'nav.attractionSetting': createElement(SettingOutlined),
  [ROUTES.attraction.claimConversion]: createElement(ForkOutlined),
  [ROUTES.enterprises.investmentProjects]: createElement(ShopOutlined),
  [ROUTES.enterprises.admissionApplications]: createElement(FileAddOutlined),
  '/enterprises/entries': createElement(AuditOutlined),
  [ROUTES.enterprises.exits]: createElement(HistoryOutlined),
  [ROUTES.enterprises.visits]: createElement(TeamOutlined),
  [ROUTES.enterprises.requests]: createElement(MessageOutlined),
  'nav.archives': createElement(FolderOpenOutlined),
  'nav.admission': createElement(AuditOutlined),
  'nav.growth': createElement(RiseOutlined),
  '/property/dashboard': createElement(BarChartOutlined),
  [ROUTES.park.workOrders]: createElement(ToolOutlined),
  '/park/leases/renewals': createElement(HistoryOutlined),
  '/park/leases/terminations': createElement(FileTextOutlined),
  [ROUTES.park.accessControl]: createElement(KeyOutlined),
  [ROUTES.park.parking]: createElement(CarOutlined),
  [ROUTES.park.meetingRoom]: createElement(CalendarOutlined),
  'nav.energy': createElement(ThunderboltOutlined),
  [ROUTES.park.iotDevices]: createElement(ApiOutlined),
  '/property/sla-rules': createElement(FieldTimeOutlined),
  'nav.handling': createElement(AuditOutlined),
  'nav.marketplace': createElement(ShopOutlined),
  'nav.resources': createElement(DeploymentUnitOutlined),
  [ROUTES.operations.activities]: createElement(CalendarOutlined),
  [ROUTES.operations.activityOps]: createElement(ProjectOutlined),
  [ROUTES.operations.policies]: createElement(FileProtectOutlined),
  [ROUTES.operations.announcements]: createElement(NotificationOutlined),
  [ROUTES.operations.content]: createElement(EditOutlined),
  [ROUTES.operations.partyBuilding]: createElement(TeamOutlined),
  [ROUTES.hr.root]: createElement(TeamOutlined),
  [ROUTES.reports.investment]: createElement(ShopOutlined),
  [ROUTES.reports.overview]: createElement(DashboardOutlined),
  [ROUTES.reports.finance]: createElement(PieChartOutlined),
  [ROUTES.reports.property]: createElement(ToolOutlined),
  [ROUTES.reports.settings]: createElement(SettingOutlined),
  'nav.portal': createElement(GlobalOutlined),
  [ROUTES.evaluation.overview]: createElement(PieChartOutlined),
  [ROUTES.evaluation.indicatorSystems]: createElement(ApartmentOutlined),
  [ROUTES.evaluation.tasks]: createElement(ScheduleOutlined),
  [ROUTES.evaluation.reports]: createElement(FileSearchOutlined),
  [ROUTES.settings.permissions]: createElement(SafetyCertificateOutlined),
  [ROUTES.settings.spaceConfig]: createElement(AppstoreOutlined),
  [ROUTES.settings.approvalConfig]: createElement(ForkOutlined),
  [ROUTES.settings.dictionaries]: createElement(BookOutlined),
  [ROUTES.settings.numberingRules]: createElement(OrderedListOutlined),
  [ROUTES.settings.auditLogs]: createElement(HistoryOutlined),
};

export const withSidebarIcon = (item: MenuDataItem): MenuDataItem => ({
  ...item,
  icon: SIDEBAR_ICONS[item.key || item.path || ''] || item.icon,
  children: item.children?.map(withSidebarIcon),
});
